/**
 * App Settings Reducers
 */

import {
  COLLAPSED_SIDEBAR,
  SHRINK_SIDEBAR,
  SET_COUNTRY,
  SET_LANGUAGE,
  SET_PAGE_HISTORY,
  REMOVE_PAGE_HISTORY,
  REFRESH_MATERIAL,
  COLLAPSED_FIELD_SIDEBAR,
  COLLAPSED_NOTIFICATION_SIDEBAR,
} from 'Actions/types';

// app config
import AppConfig from 'Constants/AppConfig';

/**
 * initial app settings
 */
const INIT_STATE = {
  navCollapsed: AppConfig.navCollapsed,
  fieldCollapsed: AppConfig.fieldCollapsed,
  notificationCollapsed: AppConfig.notificationCollapsed,
  sidebarShrink: AppConfig.sidebarShrink,
  searchFormOpen: false, // search form by default false
  themes: [
    {
      id: 1,
      name: 'primary',
    },
    {
      id: 2,
      name: 'secondary',
    },
    {
      id: 3,
      name: 'warning',
    },
    {
      id: 4,
      name: 'info',
    },
    {
      id: 5,
      name: 'danger',
    },
    {
      id: 6,
      name: 'success',
    },
  ],
  activeTheme: {
    id: 1,
    name: 'primary',
  },
  locale: AppConfig.locale,
  country: 'ko',
  languages: [
    {
      languageId: 'korean',
      locale: 'ko',
      name: 'Korean',
      icon: 'ko',
    },
    {
      languageId: 'vietnamese',
      locale: 'vi',
      name: 'Vietnamese',
      icon: 'vi',
    },
  ],
  agencyLayoutBgColors: [
    {
      id: 1,
      class: 'bg-grdnt-violet',
      active: true,
    },
    {
      id: 2,
      class: 'bg-grdnt-youtube',
    },
    {
      id: 3,
      class: 'bg-grdnt-primary-danger',
    },
    {
      id: 4,
      class: 'bg-grdnt-purple-danger',
    },
    {
      id: 5,
      class: 'bg-grdnt-purple-dark',
    },
  ],
  pageHistory: { ...JSON.parse(localStorage.getItem('pageHistory')) },
  refreshMaterial: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    // collapse sidebar
    case COLLAPSED_SIDEBAR:
      return { ...state, navCollapsed: action.isCollapsed };
    case COLLAPSED_FIELD_SIDEBAR:
      return { ...state, fieldCollapsed: action.isCollapsed };
    case COLLAPSED_NOTIFICATION_SIDEBAR:
      return { ...state, notificationCollapsed: action.isCollapsed };
    case SHRINK_SIDEBAR:
      return { ...state, sidebarShrink: action.shrinkSidebar };

    // set country
    case SET_COUNTRY:
      return { ...state, country: action.payload };

    // set language
    case SET_LANGUAGE:
      return { ...state, locale: action.payload };

    case SET_PAGE_HISTORY:
      return {
        ...state,
        pageHistory: { ...state.pageHistory, ...action.payload },
      };

    case REMOVE_PAGE_HISTORY:
      return { ...state, pageHistory: {} };

    case REFRESH_MATERIAL:
      return { ...state, refreshMaterial: !state.refreshMaterial };

    default:
      return { ...state };
  }
};
